"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAndValidate = void 0;
var parseAndValidate = function () { return function (data, props) {
    var result = data.split(',').map(function (x) { return x.split(':'); })
        .reduce(function (map, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (__assign(__assign({}, map), (_b = {}, _b[key.trim()] = value, _b)));
    }, {});
    var missingProps = props.filter(function (x) { return result[x] == undefined; });
    if (missingProps.length > 0)
        throw new Error("Fields: [".concat(missingProps.join(', '), "] is missing"));
    return result;
}; };
exports.parseAndValidate = parseAndValidate;
//# sourceMappingURL=parseAndValidate.js.map